const Profile = () => {
  return <div>My Profile page</div>;
};

export default Profile;
